export default __webpack_public_path__ + "static/media/Thumbnail3.7a9fc431.jpg";